var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { styled } from 'linaria/react';
import { LangCurrWrapper, SelectorBody, Title } from './ChannelSelector';
import { CheckboxWrapper } from '../Checkbox/CheckboxGroup';
const SelectorWrapper = /*#__PURE__*/styled('div')({
  name: "SelectorWrapper",
  class: "s1ddxhvz"
});

const MiniSelector = _a => {
  var {
    children
  } = _a,
      props = __rest(_a, ["children"]);

  return React.createElement(SelectorWrapper, Object.assign({}, props), children);
};
/** @component */


export default MiniSelector;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/ChannelSelector/MiniSelector.linaria.css");